import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=5b35e9b9&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
